"use client";

import { ArrowLeft, RefreshCcw, TriangleAlert } from "lucide-react";

type ErrorBoundaryViewProps = {
  onReload: () => void;
  onBack: () => void;
};

export function ErrorBoundaryView({ onReload, onBack }: ErrorBoundaryViewProps) {
  return (
    <div className="main-app-shell fixed inset-0 flex items-center justify-center bg-base-300" style={{ overscrollBehavior: "none" }}>
      <div
        className="main-app-shell__frame phone-frame relative min-h-0 flex overflow-hidden bg-base-300 text-base-content"
        style={{ transform: "translateZ(0)", overscrollBehavior: "none" }}
      >
        <div className="flex min-h-full w-full flex-col items-center justify-center px-5 py-8">
          <div className="w-full max-w-[320px] rounded-lg border border-base-content/10 bg-base-200/70 px-5 py-6 shadow-xl">
            <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <TriangleAlert size={26} strokeWidth={2.2} aria-hidden="true" />
            </div>

            <div className="space-y-2">
              <h1 className="text-xl font-bold leading-tight">This page couldn't load</h1>
              <p className="text-sm leading-5 text-base-content/65">
                Something went wrong. Reload the page or go back and try again.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <button type="button" className="btn btn-primary h-10 min-h-10 text-sm" onClick={onReload}>
                <RefreshCcw size={16} aria-hidden="true" />
                <span>Reload</span>
              </button>

              <button type="button" className="btn btn-primary btn-soft h-10 min-h-10 text-sm" onClick={onBack}>
                <ArrowLeft size={16} aria-hidden="true" />
                <span>Back</span>
              </button>
            </div>

            <p className="mt-4 text-xs leading-4 text-base-content/45">
              If this keeps happening, please try again later.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
